import React, { useState, useEffect } from "react";
import {
    Button,
    Input,
    InputNumber,
    Divider,
    Row,
    Col,
    Form,
    Modal,
    message,
    Card,
    Spin,
    Tabs,
    Table,
    Avatar,
} from "antd";
import IntlMessages from "../../util/IntlMessages";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import {
    HistoryOutlined,
    ArrowRightOutlined,
    FundViewOutlined,
    KeyOutlined,
} from "@ant-design/icons";
import { useDispatch, useStore, useSelector } from "react-redux";
import { loadShowPrompPrompt } from "../../appRedux/actions";
import moment from "moment";

const { TabPane } = Tabs;
const PromoPrompt = (props) => {
    const { getCurr } = props;
    const history = useHistory();
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const showPromoPrompt = useSelector(({ MainSale }) => MainSale.showPromoPrompt);
    const getPromoPrompt = useSelector(({ MainSale }) => MainSale.getPromoPrompt);

    const [getIsSpinning, setIsSpinning] = useState(false);

    function handleCancel() {
        dispatch(loadShowPrompPrompt(false));
        // setIsPromoCodeVisible(false);
    }

    const columns = [
        {
            title: <IntlMessages id="products.addpricebook.products" />,
            dataIndex: "productName",
            key: "productName",
            render: (text, record, key) => {
                return (
                    <span>
                        {text}
                    </span>
                );
            },
        },
    ];

    const columnsGet = [
        {
            title: <IntlMessages id="products.addpricebook.products" />,
            dataIndex: "productName",
            key: "productName",
            render: (text, record, key) => {
                return (
                    <span>
                        {text}
                    </span>
                );
            },
        },
    ];

    return (
        <Modal
            visible={showPromoPrompt}
            title={
                <Row justify="center">
                    <h1>
                        <strong>{getPromoPrompt.promotionName ? getPromoPrompt.promotionName : ""}</strong>
                    </h1>
                </Row>
            }
            onCancel={() => handleCancel()}
            centered={true}
            width={"auto"}
            footer={null}
        >
            <Spin
                tip={"Loading"}
                spinning={getIsSpinning}
                size="large"
            >
                <div className="custom-promoadd-maindiv">
                    <Row justify="center">
                        <Col style={{ textAlign: "center" }} span={8}>
                            <h2>
                                <IntlMessages id="products.promoadd.dur" />
                            </h2>
                            <br />
                            <h4 style={{ marginTop: -20 }}>
                                {getPromoPrompt.startDate ? `${moment(getPromoPrompt.startDate).format("DD/MM/YYYY")}
                                to ${moment(getPromoPrompt.endDate).format("DD/MM/YYYY")}` : ""}
                            </h4>
                        </Col>
                        <Col style={{ textAlign: "center" }} span={8}>
                            <h2>
                                <IntlMessages id="products.promoadd.ava" />
                            </h2>
                            <br />
                            <h4 style={{ marginTop: -20 }}>
                                {getPromoPrompt.nbrOfOutlet == 0 ? (
                                    <IntlMessages id="promoprompt.alloutlets" />
                                ) :
                                    getPromoPrompt.nbrOfOutlet > 1 ?
                                        <>
                                            {`${getPromoPrompt.nbrOfOutlet} `}
                                            <IntlMessages id="products.promoadd.out" />
                                        </> :
                                        <>
                                            {`${getPromoPrompt.nbrOfOutlet} `}
                                            <IntlMessages id="products.addpricebook.outlets" />
                                        </>
                                }
                            </h4>
                        </Col>
                        <Col style={{ textAlign: "center" }} span={8}>
                            <h2>
                                <IntlMessages id="products.promoadd.custar" />
                            </h2>
                            <br />
                            <h4 style={{ marginTop: -20 }}>
                                {getPromoPrompt.isEveryone ?
                                    <IntlMessages id="products.promoadd.tarcard1" />
                                    :
                                    <IntlMessages id="products.promoadd.tarcard2" />
                                }
                            </h4>
                        </Col>
                    </Row>

                    <Tabs defaultActiveKey="1" size="small">
                        <TabPane
                            tab={
                                <>
                                    <IntlMessages id="promoprompt.buyatleast"
                                        values={{
                                            strong: chunks => <strong>{chunks}</strong>,
                                            title: getPromoPrompt.quantity ? getPromoPrompt.quantity : 1,
                                        }}
                                    />
                                </>
                            }
                            key="1"
                        >
                            {getPromoPrompt && getPromoPrompt.rewardSpecifications
                                && getPromoPrompt.rewardSpecifications.isSave && (
                                    <div style={{ textAlign: "center", marginBottom: 10, marginTop: 4 }}>
                                        <IntlMessages id="promoprompt.by"
                                            values={{
                                                strong: chunks => <strong>{chunks}</strong>,
                                                title: getPromoPrompt.quantity ? getPromoPrompt.quantity : 1,
                                            }}
                                        />
                                        <IntlMessages id="promoprompt.save"
                                            values={{
                                                strong: chunks => <strong>{chunks}</strong>,
                                                title: getPromoPrompt && getPromoPrompt.rewardSpecifications
                                                    && getPromoPrompt.rewardSpecifications.isSaveAmount ?
                                                    `${getCurr.currencyCode ? getCurr.currencyCode :
                                                        getCurr.currencySymbol ? getCurr.currencySymbol : ""} 
                                                    ${getPromoPrompt.rewardSpecifications.rewardValue ? getPromoPrompt.rewardSpecifications.rewardValue : ""}` :
                                                    `${getPromoPrompt.rewardSpecifications.rewardValue ? getPromoPrompt.rewardSpecifications.rewardValue : ""}%`,
                                            }}
                                        />
                                    </div>
                                )}
                            {getPromoPrompt && getPromoPrompt.rewardSpecifications
                                && getPromoPrompt.rewardSpecifications.isFixPay && (
                                    <div style={{ textAlign: "center", marginBottom: 10, marginTop: 4 }}>
                                        <IntlMessages id="promoprompt.by"
                                            values={{
                                                strong: chunks => <strong>{chunks}</strong>,
                                                title: getPromoPrompt.quantity ? getPromoPrompt.quantity : 1,
                                            }}
                                        />
                                        <IntlMessages id="promoprompt.fix"
                                            values={{
                                                strong: chunks => <strong>{chunks}</strong>,
                                                title: `${getCurr.currencyCode ? getCurr.currencyCode :
                                                    getCurr.currencySymbol ? getCurr.currencySymbol : ""} 
                                                ${getPromoPrompt.rewardSpecifications.rewardValue ? getPromoPrompt.rewardSpecifications.rewardValue : ""}`,
                                            }}
                                        />
                                    </div>
                                )}
                            <Table
                                className="gx-table-responsive"
                                columns={columns}
                                dataSource={getPromoPrompt.promoProducts ? getPromoPrompt.promoProducts : []}
                            />
                        </TabPane>

                        {(getPromoPrompt && getPromoPrompt.rewardSpecifications
                            && getPromoPrompt.rewardSpecifications.isGetItems) && (
                                <TabPane
                                    tab={
                                        <>
                                            <IntlMessages id="promoprompt.get"
                                                values={{
                                                    strong: chunks => <strong>{chunks}</strong>,
                                                    title: getPromoPrompt.rewardSpecifications && getPromoPrompt.rewardSpecifications.quantity ?
                                                        getPromoPrompt.rewardSpecifications.quantity : 1,
                                                }}
                                            />
                                        </>
                                    }
                                    key="2"
                                >
                                    {getPromoPrompt.rewardSpecifications && !getPromoPrompt.rewardSpecifications.isSpecificProduct
                                        && (
                                            <h3 style={{ marginTop: 14, color: '#678e98' }}>
                                                <IntlMessages id="promo.prompt.allprodsincluded" />
                                            </h3>
                                        )}
                                    {getPromoPrompt.rewardSpecifications && getPromoPrompt.rewardSpecifications.rewardProducts &&
                                        getPromoPrompt.rewardSpecifications.rewardProducts.length > 0 && (
                                            <Table
                                                className="gx-table-responsive"
                                                columns={columnsGet}
                                                dataSource={getPromoPrompt.rewardSpecifications.rewardProducts}
                                            />
                                        )}
                                </TabPane>
                            )
                        }
                    </Tabs>
                </div>
            </Spin>
        </Modal>
    );
};

export default PromoPrompt;
